import { useNavigate } from "react-router-dom";
import useAdminListUser from "../hooks/useAdminListUser";
import useUserStore from "../store/userStore";

const UserTable = () => {
  const userToken = useUserStore((state) => state.token);
  const { data, isLoading, error } = useAdminListUser(userToken);
  const navigate = useNavigate();

  if (isLoading) return <>Loading...</>;
  if (error) return <>An error occurred while loading the data.</>;
  console.log(data);
  return (
    <table className="table table-dark table-striped table-bordered mt-5">
      <thead>
        <tr>
          <th scope="col">User id</th>
          <th scope="col">Username</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((user) => {
          return (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>
                <button
                  className="btn btn-warning mr-2"
                  onClick={() => navigate(`/admin/users/${user.username}`)}
                >
                  Edit
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default UserTable;
